import React from "react";
import "../../../../App.css";
import SideBar from "components/layout/sidebar/Sidebar";
import DashboardNavBar from "components/layout/DashboardNavBar";
import CollaboratorsVacationsForm from "./CollaboratorsVacationsForm";

const CallEditCollaboratorsVacations = ({ match }) => {

    return (
        <div>
            <DashboardNavBar />
            <SideBar />
            <CollaboratorsVacationsForm userId={match.params.id} context={"edit"} />
        </div>
    );
}

export default CallEditCollaboratorsVacations;